/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    addTooltip: "Ajouter aux colonnes",
    allTooltip: "Toutes les colonnes",
    bottomTooltip: "Tout en bas",
    clearTooltip: "Aucune colonne",
    columnsLabel: {
        nonVisibleColumn: "Colonnes disponibles",
        visibleColumn: "Colonnes sélectionnées"
    },
    configurationName: "Nom",
    downTooltip: "Descendre",
    removeTooltip: "Retirer des colonnes",
    resetTooltip: "Colonnes par défaut",
    topTooltip: "Tout en haut",
    upTooltip: "Monter"
};